import SiteLogo from "./SiteLogo";
import "./BrandLogo.scss";

/**
 * App logo — Doql wordmark asset (see SiteLogo.jsx).
 * @param {'header' | 'footer' | 'sidebar' | 'page-not-found'} variant
 * @param {boolean} [expanded] — sidebar: full wordmark vs symbol-only
 */
export default function BrandLogo({ variant = "header", expanded = true }) {
  if (variant === "sidebar") {
    return (
      <SiteLogo
        tone="dark"
        layout={expanded ? "full" : "symbol"}
        className={`brand-logo-svg brand-logo-svg--sidebar${expanded ? "" : " brand-logo-svg--sidebar-symbol"}`}
      />
    );
  }

  /* Header, footer, 404: same full-color mark (no white card) — works on dark footer + glass header */
  return (
    <SiteLogo
      tone="dark"
      layout="full"
      className={`brand-logo-svg brand-logo-svg--${variant}`}
    />
  );
}
